import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function CtaBand() {
  return (
    <section className="container pb-8">
      <div className="flex flex-wrap items-center justify-between gap-10 rounded-[20px] border border-hairline bg-[linear-gradient(135deg,#0d2a3a,hsl(var(--night))_70%)] px-8 py-14 md:px-14 md:py-20">
        <div>
          <h2 className="max-w-[480px] font-display text-[clamp(26px,3vw,38px)] font-medium">
            Un événement en préparation ?
          </h2>
          <p className="mt-3 max-w-[420px] text-muted-foreground">
            Dites-moi les dates, le lieu et ce que vous imaginez — je reviens vers vous avec une
            proposition et une disponibilité.
          </p>
        </div>
        <Button asChild size="lg">
          <Link to="/contact">Discuter de mon projet</Link>
        </Button>
      </div>
    </section>
  );
}
